import { createAction } from '@reduxjs/toolkit';

export const GET_COORPORATE_PROFILE = 'GET_COORPORATE_PROFILE';
export const SET_COORPORATE_PROFILE = 'SET_COORPORATE_PROFILE';
export const SET_ACCOUNT_RDL = 'SET_ACCOUNT_RDL';

export interface ICoorporateProfileResponse {
  companyName?: string;
  companyEmail?: string;
  picFullname?: string;
  phoneNumberPic?: string;
  accountType?: string;
  dataAccountBalance?: IDataAccountBalance;
  dataAccountBalanceIM?: IDataAccountBalance;
  methodPayment?: number;
}

export interface IDataAccountBalance {
  vaBankCode?: string;
  vaName?: string;
  vaNumber?: string;
  vaBank?: string;
  cashBalance?: number;
  methodPayment?: number;
}

export const getCoorporateProfile =
  createAction(
    GET_COORPORATE_PROFILE
  );

export const setCoorporateProfile =
  createAction<ICoorporateProfileResponse>(
    SET_COORPORATE_PROFILE
  );

export const setAccountRDL =
  createAction<IDataAccountBalance>(
    SET_ACCOUNT_RDL
  );
